/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_ButtonInputs */

const en_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Metadata`)
};

const fr_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner les métadonnées`)
};

const de_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten zusammenführen`)
};

const it_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unione dei metadati`)
};

const ru_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение метаданных`)
};

const es_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combinar metadatos`)
};

const zh_cn2_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并元数据`)
};

const ja_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータのマージ`)
};

const hi_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा मर्ज करें`)
};

const pt_pt2_metadata_merge_button = /** @type {(inputs: Metadata_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar metadados`)
};

/**
* | output |
* | --- |
* | "Merge Metadata" |
*
* @param {Metadata_Merge_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_button = /** @type {((inputs?: Metadata_Merge_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_button(inputs)
	if (locale === "de") return de_metadata_merge_button(inputs)
	if (locale === "it") return it_metadata_merge_button(inputs)
	if (locale === "ru") return ru_metadata_merge_button(inputs)
	if (locale === "es") return es_metadata_merge_button(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_button(inputs)
	if (locale === "ja") return ja_metadata_merge_button(inputs)
	if (locale === "hi") return hi_metadata_merge_button(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_button(inputs)
	return en_metadata_merge_button(inputs)
});